import React from 'react'
import withStyles from 'constructicon/with-styles'
import styles from './styles'
import RichText from '../../ui/RichText'

const Story = ({
  fundraisingPage,
  styles,
  title
}) => (
  <div>
    <RichText styles={styles.title}>
      {title}
    </RichText>
    <RichText>
      {fundraisingPage.story}
    </RichText>
  </div>
)

export default withStyles(styles)(Story)
